import React, { useState, useEffect } from "react";
import "../styles/Formularios.css";
import { useGlobal } from "../context/ContenedorGlobal";
import InputGenerico from "./InputGenerico";
import InputSelectGenerico from "./InputSelectGenerico";
import InputSelectTecPorCat from "./InputSelectTecPorCat";
import InputSelectEstados from "./InputSelectEstados";
import InputSelectFallas from "./InputSelectFallas";
import { useApiFetch } from "../utils/apiFetch";

function ModificarSolicitudes() {

    const { setModuloActual, setSubModuloActual, elementoSeleccionado, setElementoSeleccionado, logout } = useGlobal();
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const apiFetch = useApiFetch();
    const [folio, setFolio] = useState(elementoSeleccionado?.folio || "");
    const [fechaTerm, setFechaTerm] = useState(elementoSeleccionado?.fecha_term || "");
    const [fechaCierre, setFechaCierre] = useState(elementoSeleccionado?.fecha_cierre || "");
    const [idCategoria, setIdCategoria] = useState(elementoSeleccionado?.id_categoria || "");
    const [idTecnico, setIdTecnico] = useState(elementoSeleccionado?.id_tecnico || "");
    const [idEstado, setIdEstado] = useState(elementoSeleccionado?.id_estado || "");
    const [idFalla, setIdFalla] = useState(elementoSeleccionado?.id_falla || "");
    const [notas, setNotas] = useState(elementoSeleccionado?.notas_solucion || "");
    const [idEvidencia, setIdEvidencia] = useState("");
    const [nombreArchivo, setNombreArchivo] = useState("");
    const [archivo, setArchivo] = React.useState(null);

    // Función para modificar la solicitud (datos más carga de archivo en caso de aplicar)
    const handleModificarSolicitud = async () => {
        try {
            let archivoBase64 = null;
            if (archivo) {
                archivoBase64 = await toBase64(archivo); // Se convierte a base64 en archivo
            }

            const payload = {
                folio,
                id_estado: idEstado,
                id_categoria: idCategoria,
                id_tecnico: idTecnico,
                id_falla: idFalla,
                notas_solucion: notas,
                fecha_term: fechaTerm,
                fecha_cierre: fechaCierre,
                id_evidencia: idEvidencia,
                evidencia: nombreArchivo,
                archivo: archivoBase64 // Se manda el archivo en base64
            };

            console.log("Payload enviado:", payload);

            const data = await apiFetch("modificar_solicitud.php", {
                method: "POST",
                body: JSON.stringify(payload)
            }, logout);

            if (data.status === "ok") {
                setSuccess("Solicitud modificada correctamente.");
                setTimeout(() => {
                    setModuloActual("Solicitudes");
                    setSubModuloActual(null);
                }, 3000);
            } else {
                setError("Error al modificar: " + (data.message || "Error desconocido."));
                setTimeout(() => {
                    setModuloActual("Solicitudes");
                    setSubModuloActual(null);
                }, 3000);
            }
        } catch (err) {
            setError("Error de conexión: " + err.message);
        }
    };

    // Función para convertir a base 64
    const toBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file); // Convierte a base64 con prefijo data
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    // Función para manejar el cambio de archivo
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setArchivo(file);
        if (file) {
            setNombreArchivo(file.name); // Asigna el nombre del archivo
        }
    };

    // Efecto secundario, cuando se defina una fecha de cierre de solicitud, el idEvidencia toma el valor del folio
    useEffect(() => {
        if (fechaCierre) {
            setIdEvidencia(folio);
        }
    }, [fechaCierre, folio]);

    return (
        <div className="sesion-form">

            {success && (
                <div className="success">
                    {success}
                </div>
            )}
            {error && (
                <div className="error">
                    {error}
                </div>
            )}

            <div>
                <h2>Folio: {folio}</h2>
            </div>

            <InputSelectEstados
                idEstado={idEstado}
                setIdEstado={setIdEstado}
                estadoActualText=""
                idEntidad={4}
                label="Estado de la solicitud"
            />

            {idEstado === 12 && !fechaTerm && (
                <>
                    <label>Fecha de término:</label>
                    <input
                        type="date"
                        value={fechaTerm}
                        onChange={(e) => setFechaTerm(e.target.value)}
                    />
                </>
            )}

            {idEstado === 13 && fechaTerm && !fechaCierre && (
                <>
                    <label>Fecha de cierre:</label>
                    <input
                        type="date"
                        value={fechaCierre}
                        onChange={(e) => setFechaCierre(e.target.value)}
                    />
                </>
            )}

            <InputSelectGenerico
                idSeleccionado={idCategoria}
                setIdSeleccionado={setIdCategoria}
                label="Categoría"
                apiUrl={`consultar_categorias.php`}
                valueField="id_categoria"
                displayField="categoria"
                readOnly={false}
                showDefaultOption={false}
                defaultOptionText="Seleccione una categoría"
            />

            {idCategoria && (
                <InputSelectTecPorCat
                    idCategoria={idCategoria}
                    idSeleccionado={idTecnico}
                    setIdSeleccionado={setIdTecnico}
                />
            )}

            {idTecnico && idCategoria && (
                <div>
                    <InputSelectFallas
                        idCategoria={idCategoria}
                        idSeleccionado={idFalla}
                        setIdSeleccionado={setIdFalla}
                    />

                    <InputGenerico
                        value={notas}
                        setValue={setNotas}
                        label="Notas / solución"
                        maxLength={255}
                        allowedChars="A-Za-z0-9ñÑáéíóúÁÉÍÓÚ._/\- "
                        placeholder="Escriba su texto aquí"
                        title="Sea preciso con sus notas"
                    />

                    {idEstado === 13 && (
                        <InputGenerico
                            value={idEvidencia}
                            setValue={setIdEvidencia}
                            label="Evidencia"
                            maxLength={4}
                            allowedChars="0-9"
                            placeholder="10"
                            title="Ingrese solo dígitos"
                            readOnly={true}
                        />
                    )}

                </div>
            )}

            {((([8, 9, 10, 11].includes(Number(idEstado))) && !fechaTerm && !fechaCierre) || ((Number(idEstado)) === 12 && fechaTerm)) && (
                <div className="form-buttons">
                    <button type="button" onClick={handleModificarSolicitud}>
                        Modificar solicitud
                    </button>
                </div>
            )}

            {((Number(idEstado)) === 13 && fechaTerm && fechaCierre) && (
                <div >
                    <div className="form-buttons">
                        <input type="file" onChange={handleFileChange} />
                    </div>

                    {archivo && (
                        <div className="form-buttons">
                            <button onClick={handleModificarSolicitud}>Cerrar solicitud</button>
                        </div>
                    )}

                </div>
            )}

        </div>
    );
}

export default ModificarSolicitudes;